import { render, staticRenderFns } from "./ChatDrawer.vue?vue&type=template&id=65f35f12&scoped=true"
import script from "./ChatDrawer.vue?vue&type=script&lang=js"
export * from "./ChatDrawer.vue?vue&type=script&lang=js"
import style0 from "./ChatDrawer.vue?vue&type=style&index=0&id=65f35f12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f35f12",
  null
  
)

export default component.exports